import {
  useInvestmentFactBatchesList as useInvestmentFactBatchesListQuery,
  useInvestmentFactBatchGet as useInvestmentFactBatchGetQuery,
  type FactGenerationBatchSurfaceDto,
} from '../../../api/generated/client';
import { ROUTE_IDS, OPERATION_IDS } from '@finance/contracts';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';

function selectFactBatchListRows(response: unknown): FactGenerationBatchSurfaceDto[] {
  return selectApiData(response as ApiSuccessEnvelope<FactGenerationBatchSurfaceDto[]>) ?? [];
}

function selectFactBatchDetail(response: unknown): FactGenerationBatchSurfaceDto {
  return selectApiData(response as ApiSuccessEnvelope<FactGenerationBatchSurfaceDto>);
}

export function useFactBatchList(): ListHookResult<FactGenerationBatchSurfaceDto[]> {
  return useInvestmentFactBatchesListQuery({ query: { select: selectFactBatchListRows } });
}

export function useFactBatchGet(id: string): GetHookResult<FactGenerationBatchSurfaceDto> {
  return useInvestmentFactBatchGetQuery(id, { query: { select: selectFactBatchDetail } });
}

export const FACT_BATCHES_HOOKS: ResourceHookBinding<FactGenerationBatchSurfaceDto[], FactGenerationBatchSurfaceDto> = {
  useList: useFactBatchList,
  selectList: selectFactBatchListRows,
  useGet: useFactBatchGet,
  selectDetail: selectFactBatchDetail,
  rowIdExtractor: (row) => (typeof row.id === 'string' ? row.id : undefined),
  rowIdField: 'id',
  routeParameterName: 'id',
  paramName: 'id',
  listRouteId: ROUTE_IDS.DATA_FACT_BATCHES,
  detailRouteId: ROUTE_IDS.DATA_FACT_BATCH_DETAIL,
  readOperationId: OPERATION_IDS.FACT_BATCH_GET,
  detailDescriptorId: 'detail.factBatches',
};
